import { Component, Signal, effect } from '@angular/core';
import { OAuthService } from '../services/o-auth.service';
import { ACCOUNT_FILTER_DEFAULT_REALM, poe1 } from '../../game';
import { LOCAL_STORAGE_KEY_FILTER_DEFAULT_REALM } from '../const';
import { RealmSelectorDialogComponent } from '../realm-selector-dialog/realm-selector-dialog.component';
import { BaseComponent } from '../common/base.component';

@Component({
  selector: 'app-login',
  imports: [RealmSelectorDialogComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent extends BaseComponent {
  userName: Signal<string | null>;
  loginStatus: Signal<string | null>;

  showRealmPicker = false;
  selectedRealm = localStorage.getItem(LOCAL_STORAGE_KEY_FILTER_DEFAULT_REALM) || ACCOUNT_FILTER_DEFAULT_REALM;

  constructor(private loginService: OAuthService) {
    super();
    this.userName = this.loginService.userName;
    this.loginStatus = this.loginService.status;

    effect(() => {
      const loginEvent = this.loginService.loginSuccessEvent();
      if (loginEvent && poe1 && !localStorage.getItem(LOCAL_STORAGE_KEY_FILTER_DEFAULT_REALM)) {
        this.showRealmPicker = true;
      }
    });
  }

  login($event: any) {
    $event.preventDefault();
    this.loginService.login();
  }

  logout($event: any) {
    $event.preventDefault();
    this.loginService.logout();
  }
}
